import { TermsConditionProps } from './terms.interface';
import * as S from './termsCondition.styles';

const TermsCondition = ({ termsItem, title }: TermsConditionProps) => (
  <S.TermCondition>
    <S.TermConditionTitle>{title}</S.TermConditionTitle>
    <S.TermConditionUl>
      {termsItem.map((text, index) => (
        <S.TermConditionLi key={index}>{text}</S.TermConditionLi>
      ))}
    </S.TermConditionUl>
  </S.TermCondition>
);

export default TermsCondition;
